module.exports = __webpack_public_path__ + "media/yir-short.4705097c.webm";